export function getUrlParameter(sParam: string): string | true {
    const sPageURL = decodeURIComponent(window.location.search.substring(1));
    const sURLVariables = sPageURL.split("&");
    let sParameterNameValue: string[];
    let sParameterName: string | true;

    for (const sURLVariable of sURLVariables) {
        sParameterNameValue = sURLVariable.split("=");

        if (sParameterNameValue[0] === sParam) {
            if (sParameterNameValue[1] === undefined) {
                sParameterName = true;
            } else {
                sParameterName = sParameterNameValue[1];
            }
        }
    }

    // @ts-expect-error Check for typing
    return sParameterName;
}
